import React, { forwardRef, ComponentProps } from 'react';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.996 4.741a.678.678 0 0 1 .483 1.14L8.87 8.504a.715.715 0 0 1-.969 0L6.717 7.318a.681.681 0 0 1 .967-.958l.696.697 2.141-2.134a.679.679 0 0 1 .475-.182Z M12.476 2.355A2.018 2.018 0 0 1 14.5 4.371V9.27a2.017 2.017 0 0 1-2.006 2.006H6.34l-2.712 2.215a.678.678 0 0 1-.424.154.725.725 0 0 1-.299-.073.661.661 0 0 1-.38-.605V4.073a1.999 1.999 0 0 1 1.98-1.718h7.972ZM4.504 3.711a.662.662 0 0 0-.65.66v7.15l1.708-1.447h.054l.099-.1a.48.48 0 0 1 .09-.053.38.38 0 0 1 .136 0h6.535a.652.652 0 0 0 .65-.651v-4.9a.66.66 0 0 0-.65-.66H4.504Zm-1.997.579a.31.31 0 0 1 0-.127c-.003.042 0 .085 0 .127Z';

const draw24px =
  'M17.056 6.25a.858.858 0 0 1 .611 1.442l-5.588 5.6a.904.904 0 0 1-1.222 0l-2.07-2.069a.862.862 0 0 1 1.224-1.212l1.451 1.451 4.994-4.982a.858.858 0 0 1 .6-.23Z M19.359 2.606a3.144 3.144 0 0 1 3.143 3.143v8.434a3.143 3.143 0 0 1-3.143 3.143H8.685L3.93 21.2a.892.892 0 0 1-.549.194.811.811 0 0 1-.365-.08.87.87 0 0 1-.492-.776V5.748a1.852 1.852 0 0 1 0-.25.32.32 0 0 1 0-.103 3.144 3.144 0 0 1 3.12-2.789h13.714ZM5.645 4.321a1.428 1.428 0 0 0-1.429 1.428v12.983l3.67-2.983a.754.754 0 0 1 .308-.137.687.687 0 0 1 .262 0H19.36a1.43 1.43 0 0 0 1.428-1.429V5.75a1.429 1.429 0 0 0-1.428-1.43H5.645ZM2.514 5.498a.149.149 0 0 0-.012.068v.183a1.852 1.852 0 0 1 0-.251h.012Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SpeechBubbleCheckedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'speechBubbleChecked')) as IconWithRender;

SpeechBubbleCheckedIcon.displayName = 'SpeechBubbleCheckedIcon';
SpeechBubbleCheckedIcon.propTypes = Icon.propTypes;
SpeechBubbleCheckedIcon.renderIcon = (props) => (
  <SpeechBubbleCheckedIcon {...props} />
);

export default SpeechBubbleCheckedIcon;
